import { parseFlexibleDateToIso } from '@shared/utils/fmtDate';
import {
  clearFormDraft,
  loadFormDraft,
  saveFormDraft,
  type FormDraftPayload,
} from '@presentation/shell/formDraft';

/**
 * Brouillon local du formulaire salarié — reprise après coupure / plantage.
 * Clé localStorage par tenant (+ id salarié en édition).
 */
const DRAFT_PREFIX = 'nexxus.salarie.draft.v1';

export interface SalarieFormDraftPayload {
  savedAt: string;
  fields: Record<string, string>;
  activeTab?: string;
}

export function saveSalarieFormDraft(
  tenantId: string,
  salarieId: string | 'new',
  fields: Record<string, string>,
  activeTab?: string,
): void {
  saveFormDraft(
    DRAFT_PREFIX,
    tenantId,
    salarieId,
    fields,
    activeTab ? { activeTab } : undefined,
  );
}

export function loadSalarieFormDraft(
  tenantId: string,
  salarieId: string | 'new',
): SalarieFormDraftPayload | null {
  const draft: FormDraftPayload | null = loadFormDraft(DRAFT_PREFIX, tenantId, salarieId);
  if (!draft) return null;
  return {
    savedAt: draft.savedAt,
    fields: draft.fields,
    activeTab: draft.meta?.['activeTab'],
  };
}

export function clearSalarieFormDraft(tenantId: string, salarieId: string | 'new'): void {
  clearFormDraft(DRAFT_PREFIX, tenantId, salarieId);
}

/** Collecte les valeurs des contrôles nommés du formulaire (hors fichiers). */
export function collectFormFieldValues(form: HTMLFormElement): Record<string, string> {
  const out: Record<string, string> = {};
  const elements = form.querySelectorAll<
    HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
  >('input[name], select[name], textarea[name]');
  elements.forEach((el) => {
    if (!el.name || el.type === 'file' || el.classList.contains('nx-date-native')) return;
    if (el instanceof HTMLInputElement && (el.type === 'checkbox' || el.type === 'radio')) {
      if (el.checked) out[el.name] = el.value;
      return;
    }
    out[el.name] = el.value;
  });
  return out;
}

export function applyFormFieldValues(form: HTMLFormElement, fields: Record<string, string>): void {
  for (const [name, value] of Object.entries(fields)) {
    const el = form.querySelector<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
      `[name="${CSS.escape(name)}"]`,
    );
    if (!el || el.classList.contains('nx-date-native')) continue;
    if (el instanceof HTMLInputElement && (el.type === 'checkbox' || el.type === 'radio')) {
      el.checked = el.value === value;
      continue;
    }
    el.value = value;
  }
  form.querySelectorAll<HTMLInputElement>('.nx-date-text').forEach((text) => {
    const native = form.querySelector<HTMLInputElement>(`.nx-date-native[data-for="${text.name}"]`);
    if (!native) return;
    native.value = parseFlexibleDateToIso(text.value) ?? '';
  });
}
